const BETA_MAC_CATEGORY = "MAC";
const GAMMA_MAC_CATEGORY = "MacOS";
const PROD_MAC_CATEGORY = "Mac";

const WINDOWS_CATEGORY = "Windows";
const LINUX_CATEGORY = "Linux";

export const getUserOS = (): string[] => {
  const userAgent = window.navigator.userAgent.toLowerCase();

  if (userAgent.includes("mac")) {
    return [BETA_MAC_CATEGORY, GAMMA_MAC_CATEGORY, PROD_MAC_CATEGORY];
  }

  if (userAgent.includes("win")) {
    return [WINDOWS_CATEGORY];
  }

  if (userAgent.includes("linux") && !userAgent.includes("android")) {
    return [LINUX_CATEGORY];
  }

  return [""];
};
